import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, HeartHandshake, Wrench, Phone } from 'lucide-react';
const pillars = [{
  icon: MapPin,
  title: 'Local, Not A Franchise',
  desc: 'A Monterey County owner-operator — not a call center in another state.'
}, {
  icon: Wrench,
  title: 'Built For Hard Jobs',
  desc: 'Garages, foreclosures, sheds, concrete, contractor sites. We scale to the work.'
}, {
  icon: HeartHandshake,
  title: 'Handled With Respect',
  desc: 'Including the hardest days — like clearing a loved one\'s home after they pass.'
}];
export function AboutJose() {
  return <section id="why-us" className="py-20 lg:py-28 bg-white" data-id="element-20" data-mp="1ly6xrb9laat1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-21" data-mp="1gzcey9bmgm8x">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center" data-id="element-22" data-mp="1gxrl6lx4t7c4">
          {/* Logo panel */}
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.55,
          ease: [0.23, 1, 0.32, 1]
        }} className="lg:col-span-5" data-id="element-23" data-mp="3iqyyjpt6pevd">
            <div className="relative rounded-3xl bg-[#0E0E0E] p-10 sm:p-14 overflow-hidden" data-id="element-24" data-mp="xb83kuinkpzq">
              <div className="absolute inset-0 bg-grid-faint opacity-[0.04]" data-id="element-25" data-mp="128qfmtryvlby" />
              <div className="absolute -bottom-20 -left-20 w-72 h-72 bg-[#C8102E] opacity-20 blur-[110px] rounded-full" data-id="element-26" data-mp="171jl5jv9exp3" />
              <img src="https://cdn.magicpatterns.com/uploads/hJguF2FSF4VF7Gq2iQCUa2/Jose_Junk_Removal_Logo_(1).png" alt="Jose's Junk Removal & Hauling logo" className="relative w-full max-w-sm mx-auto drop-shadow-2xl" data-id="element-27" data-mp="1bzl4m5wlkz13" />
              <div className="relative mt-8 flex items-center justify-center gap-2 text-white" data-id="element-28" data-mp="1pycax657xgeo">
                <MapPin size={16} className="text-[#C8102E]" data-id="element-29" data-mp="3mt7dt338q423" />
                <span className="text-xs font-bold tracking-[0.2em] uppercase" data-id="element-30" data-mp="3rqh1oeaze7nt">
                  Monterey County, California
                </span>
              </div>
            </div>
          </motion.div>

          {/* Story */}
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.55,
          delay: 0.1,
          ease: [0.23, 1, 0.32, 1]
        }} className="lg:col-span-7" data-id="element-31" data-mp="tyqqe6qe818k">
            <span className="text-[11px] tracking-[0.25em] font-bold uppercase text-[#C8102E]" data-id="element-32" data-mp="1hul476oah46c">
              The Owner Behind The Truck
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-[#1A1A1A] leading-[1.05] mt-4 mb-8" data-id="element-33" data-mp="1cugt5w65h1ni">
              WHO IS <span className="text-[#C8102E]" data-id="element-34" data-mp="1mm30vija4ili">JOSE'S?</span>
            </h2>

            <blockquote className="border-l-4 border-[#C8102E] pl-6 mb-8" data-id="element-35" data-mp="1mo7g2wmmp413">
              <p className="text-xl md:text-2xl font-medium text-[#1A1A1A] leading-snug" data-id="element-36" data-mp="20mdugtbz4bad">
                "When someone calls for help, you show up. You work hard. You get
                it done — and you leave the space better than you found it."
              </p>
              <cite className="not-italic block text-sm font-bold uppercase tracking-widest text-gray-500 mt-4" data-id="element-37" data-mp="2k879e3jqtifj">
                — Jose, Owner
              </cite>
            </blockquote>

            <p className="text-lg text-gray-600 leading-relaxed mb-6" data-id="element-38" data-mp="2a9848uy6s4xa">
              Jose built this company on that one belief. Over the years his
              team has cleared garages, gutted foreclosures, demolished
              crumbling sheds, hauled tons of concrete, and cleaned up after
              contractors across Monterey County.
            </p>

            <p className="text-lg text-gray-600 leading-relaxed mb-10" data-id="element-39" data-mp="1mhsvokftgrdl">
              When you call, you're talking to people who actually care — who
              show up on time and treat your property with respect.
            </p>

            {/* Pillars */}
            <div className="grid sm:grid-cols-3 gap-4 mb-10" data-id="element-40" data-mp="1hjrclzie4s24">
              {pillars.map(pillar => {
              const Icon = pillar.icon;
              return <div key={pillar.title} className="bg-[#F9F9F9] border border-gray-200 rounded-2xl p-5" data-id="element-41" data-mp="15hzst808tm3q">
                    <span className="flex w-10 h-10 rounded-lg bg-white border border-gray-200 items-center justify-center text-[#C8102E] mb-4" data-id="element-42" data-mp="10pgeu9xn8oye">
                      <Icon size={19} data-id="element-43" data-mp="rrehc4d4cefv" />
                    </span>
                    <h3 className="font-bold text-[#1A1A1A] text-sm leading-tight mb-2" data-id="element-44" data-mp="ms1moxg0a32q">
                      {pillar.title}
                    </h3>
                    <p className="text-[13px] text-gray-600 leading-relaxed" data-id="element-45" data-mp="htqc2khvzojg">
                      {pillar.desc}
                    </p>
                  </div>;
            })}
            </div>

            <a href="tel:8312407401" className="inline-flex items-center gap-2 text-[#C8102E] font-bold uppercase tracking-wider text-sm hover:text-[#8B0A20] transition-colors" data-id="element-46" data-mp="2c6g8p9zn3buj">
              <Phone size={17} data-id="element-47" data-mp="2fmt11gy97mhr" />
              Talk to Jose's team — (831) 240-7401
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}